import React from "react"

export const TableBody = ({
    getTableBodyProps,
    rows,
    prepareRow,
    rowClassName,
    columns
}) => {

    return (
        <tbody {...getTableBodyProps()}>
            {// Loop over the table rows
                rows.map(row => {
                    // Prepare the row for display
                    prepareRow(row)
                    return (
                        // Apply the row props
                        <tr className={"c-table__row p-5 lg:p-0"} {...row.getRowProps()}>
                            {// Loop over the rows cells
                                row.cells.map(cell => {
                                    // Apply the cell props
                                    return (
                                        <td className={`c-table__cell w-full md:p-5 ${rowClassName}`} {...cell.getCellProps()}>
                                            <span className={"text-xs"}>{cell.render("Cell")}</span>
                                        </td>
                                    )
                                })}
                        </tr>
                    )
                })}
        </tbody>
    )
}
